export default "__VITE_ASSET__lCQ_ThHE__"